/**
 * ThemeToggle — botão ☀/☽ pra alternar tema local do module_lab.
 *
 * Posição: top-right em mobile alinha com MasterActivityControls/
 * InteractionModeBadge? Não — ponho aqui bottom-left um pouco acima do
 * MasterControlsPill pra não colidir. No player, fica top-right abaixo do
 * InteractionModeBadge/XpBadge.
 *
 * Decisão: posicionamento simples via prop `position`. O dono (master ou
 * player view) escolhe onde colocar.
 */

import { useLabTheme } from '../hooks/useLabTheme'

interface Props {
  /** Posição preset. Default: 'bottom-right' (pode ser sobrescrito). */
  position?: 'bottom-right' | 'top-right' | 'inline'
}

export function ThemeToggle({ position = 'bottom-right' }: Props) {
  const { theme, toggle } = useLabTheme()
  const isDark = theme === 'dark'

  const positionStyle: React.CSSProperties =
    position === 'inline'
      ? {}
      : position === 'top-right'
        ? { position: 'fixed', top: 12, right: 12, zIndex: 45 }
        : { position: 'fixed', bottom: 16, right: 16, zIndex: 48 }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Usar tema claro' : 'Usar tema escuro'}
      title={isDark ? 'Usar tema claro' : 'Usar tema escuro'}
      style={{
        ...positionStyle,
        minWidth: 40,
        minHeight: 40,
        padding: 8,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: isDark ? '#1A1D23' : '#FFFFFF',
        color: isDark ? '#F5F5F0' : '#0F1115',
        border: `1px solid ${isDark ? '#2A2D33' : '#D8D5CB'}`,
        borderRadius: 'var(--radius-lab-sm, 6px)',
        fontFamily: 'var(--font-lab-mono, monospace)',
        fontSize: 16,
        fontWeight: 700,
        cursor: 'pointer',
        boxShadow: 'var(--lab-shadow-sm, 0 2px 6px rgba(15,17,21,0.06))',
      }}
    >
      {isDark ? '☀' : '☽'}
    </button>
  )
}
